export const LIVE_ROOM_NAMES = [
  '云朵借我一支笔', '今天也画得开心', '友友的涂鸦角', '一起来画小星星', '铅笔盒开会啦',
  '灵感正在冒泡', '画纸上的下午茶', '奶糖色的星期天', '小画家请进', '不许笑我的画',
  '认真乱画俱乐部', '星星落在画纸上', '快乐涂鸦营业中', '画一朵好心情', '猜猜我的小心思',
  '月亮也来画两笔', '今天轮到你啦', '画笔交个朋友', '彩虹不用排队', '画得像就鼓掌',
  '灵感慢慢来', '橡皮暂时休假', '一桌小小画家', '画纸里的游乐园', '画一口甜甜圈',
  '颜料罐碰个杯', '周末画个痛快', '友友猜中了吗', '画笔尖的约定', '开心就添一笔',
  '小小灵感车站', '好朋友画一桌', '晚风吹开画册', '一起画到月亮来', '今天画点可爱的',
  '画个圆圆的愿望', '快乐不用打草稿', '星光涂鸦放映室', '画纸边的悄悄话', '我的画有点想法',
  '猜对请收小红花', '画一场晴天', '彩色铅笔集合', '友友请多指教', '云端美术课',
  '灵感正在路上', '画完就去吃甜品', '开心画画同学会',
  '铅笔偷偷许个愿', '画一碗星星面', '云朵颜料铺', '今日灵感不限量',
  '纸飞机停靠站', '一起涂个晴天', '晚安之前画一笔', '糖果色的约定',
  '橡皮与铅笔的茶会', '今天也是小画家', '把快乐画给你', '友友灵感放映厅',
] as const;
